import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import {observer} from 'mobx-react'
import { IMP_CPID, IMP_PG, ROOT_URL } from '../../config/const'
import {rootStore} from '../../mobx/store'
import { formatNumber } from '../../helper/common'

const PayDo = observer((props) => {
  const context = useContext(Page_settings)
  useEffect(() => {
    init()

    let url = new URL(window.location.href)
    const page = url.searchParams.get('page')
    if (page === null) return
    const error_code = url.searchParams.get('error_code')
    if (error_code !== null) {
      const error_msg = url.searchParams.get('error_msg')
      context.showAlert(error_msg)
      props.history.replace(page)
      return
    }
    const imp_uid = url.searchParams.get('imp_uid')
    const amount = url.searchParams.get('amount')
    const point = url.searchParams.get('point')
    subVerify(imp_uid, amount, point, page)
  }, [])

  const init = () => {
    let state = props.location.state
    const page = state?.page
    const mode = state?.mode
    const point = state?.point
    const vatFee = state?.vatFee ?? 0
    if (point === undefined) return
    const pg = mode == 1 ? 'danal_tpay' : IMP_PG
    const method = mode == 1 ? 'trans' : 'phone'
    const amount = point * (100 + vatFee) / 100
    const me = rootStore.getMe
    window.IMP.request_pay({
      pg: `${pg}.${IMP_CPID}`,
      pay_method: method,
      merchant_uid: 'order' + new Date().getTime(),
      name: `${formatNumber(point)}포인트 구매`,
      amount: amount,
      buyer_email: me.mb_email,
      buyer_name: me.mb_name,
      buyer_tel: me.mb_tel,
      buyer_addr: '',
      buyer_postcode: '',
      m_redirect_url: `${ROOT_URL}/mypage/pay_do?amount=${amount}&point=${point}&page=${page}`,
    }, function (rsp) {
      //console.log(rsp)
      if (!rsp.success) {
        context.showAlert('결제처리가 실패되었습니다 - ' +  rsp.error_msg)
        props.history.replace(page)
        return
      }
      subVerify(rsp.imp_uid, amount, point, page)
    })
  }

  const subVerify = (imp_uid, point, page) => {
    context.post('pay/imp_verify', {imp_uid: imp_uid, point: point},
      response => {
        const mb_point = response.mb_point
        const buy_point = response.buy_point
        let me = rootStore.getMe
        me.mb_point = mb_point
        me.buy_point = buy_point
        rootStore.signIn(me)
        props.history.replace(page)
      },
      true,
      err => {
        context.showAlert(err.msg)
        props.history.replace(page)
      }
    )
  }

  return (
    <React.Fragment>
      <div className='content-container'>
      </div>
    </React.Fragment>
  )
})

export default withRouter(PayDo)